import { BaseModal, BaseModalProps } from './BaseModal';

export default BaseModal;
